var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.333 3.666h1.334v1.333H6.333V3.666Zm0 2.667h1.334v4H6.333v-4Zm.667-6A6.67 6.67 0 0 0 .333 6.999 6.67 6.67 0 0 0 7 13.666a6.67 6.67 0 0 0 6.667-6.667A6.67 6.67 0 0 0 7 .333Zm0 12a5.34 5.34 0 0 1-5.333-5.334A5.34 5.34 0 0 1 7 1.666a5.34 5.34 0 0 1 5.333 5.333A5.34 5.34 0 0 1 7 12.332Z",
    fill: "#00629B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e2ecb6674df800b32db394ef90b6ee99.svg";
export { ForwardRef as ReactComponent };